module.exports = __webpack_public_path__ + "static/media/FontAwesome5_Regular.db78b935.ttf";